<template>
    <div
        class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2"
        style="height: inherit; width: inherit"
    >
        <!-- Content Header (Page header) -->
        <div v-if="$gate.isServiceAdmin()">
            <!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

            <section class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col-sm-6">
                            <h2>Manage Users</h2>
                        </div>
                        <div class="col-sm-6">
                            <ol class="breadcrumb float-sm-right">
                                <li class="breadcrumb-item">
                                    <a href="/home">Home</a>
                                </li>
                                <li class="breadcrumb-item active">
                                    {{ $route.meta.title }}
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
                <!-- /.container-fluid -->
            </section>

            <!-- Main content -->
            <section class="content">
                <br />
                <!-- main row for all icons  -->
                <div class="col-md-12">
                    <div class="card card-danger card-outline">
                        <div class="card-header">
                            <button
                                class="btn btn-danger float-right"
                                @click="addModal"
                            >
                                <i class="fa fa-plus"></i> Add User
                            </button>
                        </div>
                        <div class="card-body overflow-auto">
                            <!-- <img v-if="lots==''" src="../images/nodata.svg">	 -->
                            <div class="col-md-10 float-left">
                                <div class="row">
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <input
                                                type="number"
                                                class="form-control"
                                                min="5"
                                                value="10"
                                                v-model="results"
                                                placeholder=" Enter No. of results"
                                                @input="
                                                    getUsers(
                                                        '/api/getUsersSAdmin'
                                                    )
                                                "
                                            />
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <v-select
                                                v-model="branch"
                                                class="form-control"
                                                type="text"
                                                label="branch"
                                                :options="branches"
                                                :reduce="
                                                    (branches) =>
                                                        branches.branch_code
                                                "
                                                name="branch"
                                                placeholder="Select Branch"
                                                :value="
                                                    (branches) =>
                                                        branches.branch_code
                                                "
                                            ></v-select>
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <input
                                                type="text"
                                                class="form-control"
                                                v-model="name"
                                                placeholder=" Enter the name"
                                            />
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <select
                                                v-model="user_type"
                                                class="form-control"
                                            >
                                                <option value="#">
                                                    ---Select Usertype---
                                                </option>
                                                <option value="sys-admin">
                                                    System Administrator
                                                </option>
                                                <option value="service-tech">
                                                    Service Executive
                                                </option>
                                                <option value="service-manager">
                                                    Service Manager
                                                </option>
                                                <option value="service-agent">
                                                    Service Assistant
                                                </option>
                                                <option value="service-admin">
                                                    Service Administrator
                                                </option>
                                                <option value="purchase-admin">
                                                    Purchase Administrator
                                                </option>
                                                <option
                                                    value="purchase-manager"
                                                >
                                                    Purchase Manager
                                                </option>
                                                <option
                                                    value="replacement-manager"
                                                >
                                                    Replacement Manager
                                                </option>
                                                <option value="doa-manager">
                                                    DOA Manager
                                                </option>
                                                <option value="ext-warr-admin">
                                                    Extended Warranty Admin
                                                </option>
                                                <option value="auditor">
                                                    Auditor
                                                </option>
                                                <option value="call-agent">
                                                    Call Agent
                                                </option>
                                                <option value="user">
                                                    Customer
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="form-group float-left">
                                            <button
                                                class="btn btn-danger"
                                                @click="
                                                    getUsers(
                                                        '/api/getUsersSAdmin'
                                                    )
                                                "
                                            >
                                                <i class="fa fa-search"></i>
                                                Search
                                            </button>
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="form-group float-left">
                                            <button
                                                class="btn btn-danger"
                                                @click="reset"
                                            >
                                                <i class="fa fa-times"></i>
                                                Reset
                                            </button>
                                        </div>
                                    </div>
                                    <!--<div class="col-sm-3">
      		<div class="form-group float-left">
      			<button class="btn btn-secondary" @click="excel"><i class="fa fa-print"></i> Generate Excel</button>
      		</div>-->
                                </div>
                            </div>
                            <img v-if="users == ''" src="" />

                            <!-- content here -->
                            <datatable
                                style="margin-top: 1%"
                                :columns="columns"
                                v-else
                            >
                                <tbody>
                                    <tr v-for="man in users" :key="man.id">
                                        <td>
                                            {{ man.first_name }}
                                            {{ man.last_name }}
                                        </td>
                                        <td>{{ man.branch }}</td>
                                        <td>{{ man.user_type }}</td>
                                        <td>
                                            <div class="col-sm-12">
                                                <button
                                                    class="btn btn-danger"
                                                    @click="view(man)"
                                                >
                                                    <i class="fa fa-eye"></i>
                                                    View
                                                </button>
                                            </div>
                                            <br />
                                            <div class="col-sm-12">
                                                <button
                                                    class="btn btn-primary"
                                                    @click="edit(man)"
                                                >
                                                    <i class="fa fa-edit"></i>
                                                    Edit
                                                </button>
                                            </div>
                                            <br />
                                            <div class="col-sm-12">
                                                <button
                                                    class="btn btn-danger"
                                                    @click="passwd(man)"
                                                >
                                                    <i class="fa fa-cog"></i>
                                                    Password
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </datatable>
                            <!-- content here -->
                        </div>
                        <div class="card-footer">
                            <pagination
                                :pagination="pagination"
                                @prev="getUsers(pagination.prevPageUrl)"
                                @next="getUsers(pagination.nextPageUrl)"
                            ></pagination>
                        </div>
                    </div>
                </div>
                <!-- row end -->
            </section>
            <!-- /.content -->

            <div class="modal" tabindex="-1" role="dialog" id="addModal">
                <div class="modal-dialog modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Add User</h5>
                            <button
                                type="button"
                                class="close"
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <form @submit.prevent="addUser">
                                <div
                                    :class="[
                                        'form-group',
                                        errors.emp_id ? 'has-error' : '',
                                    ]"
                                >
                                    <label>Employee ID:</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder="Enter the ID of the employee"
                                        v-model="form.emp_id"
                                    />
                                    <span
                                        v-if="errors.emp_id"
                                        :class="['badge bg-danger']"
                                        >Please enter a valid ID.</span
                                    >
                                </div>
                                <div
                                    :class="[
                                        'form-group',
                                        errors.branch ? 'has-error' : '',
                                    ]"
                                >
                                    <label>Branch:</label>
                                    <v-select
                                        v-model="form.branch"
                                        type="text"
                                        label="BRANCH_NAME"
                                        :options="branches"
                                        :reduce="
                                            (branches) => branches.BRANCH_CODE
                                        "
                                        name="branch"
                                        placeholder="Select Branch"
                                        :value="
                                            (branches) => branches.BRANCH_CODE
                                        "
                                        @input="getEmployees"
                                    ></v-select>
                                    <span
                                        v-if="errors.branch"
                                        :class="['badge bg-danger']"
                                        >Please choose a valid branch.</span
                                    >
                                </div>
                                <div
                                    :class="[
                                        'form-group',
                                        errors.apx_user_id ? 'has-error' : '',
                                    ]"
                                >
                                    <label>APX User:</label>
                                    <v-select
                                        v-model="form.apx_user_id"
                                        type="text"
                                        label="SLPR_NAME"
                                        :options="employees"
                                        :reduce="
                                            (employees) => employees.SLPR_NAME
                                        "
                                        name="apx_user_id"
                                        placeholder="Select APX user"
                                        :value="
                                            (employees) => employees.SLPR_NAME
                                        "
                                    ></v-select>
                                    <span
                                        v-if="errors.apx_user_id"
                                        :class="['badge bg-danger']"
                                        >Please choose a valid user.</span
                                    >
                                </div>
                                <div
                                    :class="[
                                        'form-group',
                                        errors.first_name ? 'has-error' : '',
                                    ]"
                                >
                                    <label>First Name:</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder="Enter the first name of the employee"
                                        v-model="form.first_name"
                                    />
                                    <span
                                        v-if="errors.first_name"
                                        :class="['badge bg-danger']"
                                        >Please enter a valid name.</span
                                    >
                                </div>
                                <div
                                    :class="[
                                        'form-group',
                                        errors.last_name ? 'has-error' : '',
                                    ]"
                                >
                                    <label>Last Name:</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder="Enter the last name of the employee"
                                        v-model="form.last_name"
                                    />
                                    <span
                                        v-if="errors.last_name"
                                        :class="['badge bg-danger']"
                                        >Please enter a valid name.</span
                                    >
                                </div>
                                <div
                                    :class="[
                                        'form-group',
                                        errors.phone ? 'has-error' : '',
                                    ]"
                                >
                                    <label>Phone:</label>
                                    <input
                                        type="number"
                                        class="form-control"
                                        placeholder="Enter the phone number of the employee"
                                        v-model="form.phone"
                                        min="1000000000"
                                    />
                                    <span
                                        v-if="errors.phone"
                                        :class="['badge bg-danger']"
                                        >Please enter a valid number.</span
                                    >
                                </div>
                                <div
                                    :class="[
                                        'form-group',
                                        errors.email ? 'has-error' : '',
                                    ]"
                                >
                                    <label>E-mail:</label>
                                    <input
                                        type="email"
                                        class="form-control"
                                        placeholder="Enter the email of the employee"
                                        v-model="form.email"
                                    />
                                    <span
                                        v-if="errors.email"
                                        :class="['badge bg-danger']"
                                        >Please enter a valid email.</span
                                    >
                                </div>
                                <div
                                    :class="[
                                        'form-group',
                                        errors.password ? 'has-error' : '',
                                    ]"
                                >
                                    <label>Password:</label>
                                    <input
                                        type="password"
                                        class="form-control"
                                        placeholder="Enter the password of the employee"
                                        v-model="form.password"
                                    />
                                    <span
                                        v-if="errors.password"
                                        :class="['badge bg-danger']"
                                        >Please enter valid matching
                                        passwords.</span
                                    >
                                </div>
                                <div
                                    :class="[
                                        'form-group',
                                        errors.password_confirmation
                                            ? 'has-error'
                                            : '',
                                    ]"
                                >
                                    <label>Confirm Password:</label>
                                    <input
                                        type="password"
                                        class="form-control"
                                        placeholder="Enter the password of the employee"
                                        v-model="form.password_confirmation"
                                    />
                                    <span
                                        v-if="errors.password_confirmation"
                                        :class="['badge bg-danger']"
                                        >Please enter valid matching
                                        passwords.</span
                                    >
                                </div>
                                <div
                                    :class="[
                                        'form-group',
                                        errors.user_type ? 'has-error' : '',
                                    ]"
                                >
                                    <label>User Type:</label>
                                    <select
                                        v-model="form.user_type"
                                        class="form-control"
                                    >
                                        <option value="service-tech">
                                            Service Executive
                                        </option>
                                        <option value="service-manager">
                                            Service Manager
                                        </option>
                                        <option value="service-agent">
                                            Service Assistant
                                        </option>
                                        <option value="service-admin">
                                            Service Administrator
                                        </option>
                                        <option value="purchase-admin">
                                            Purchase Administrator
                                        </option>
                                        <option value="purchase-manager">
                                            Purchase Manager
                                        </option>
                                        <option value="replacement-manager">
                                            Replacement Manager
                                        </option>
                                        <option value="doa-manager">
                                            DOA Manager
                                        </option>
                                        <option value="auditor">Auditor</option>
                                        <option value="call-agent">
                                            Call Agent
                                        </option>
                                    </select>
                                    <span
                                        v-if="errors.user_type"
                                        :class="['badge bg-danger']"
                                        >Please enter valid matching
                                        passwords.</span
                                    >
                                </div>
                                <div
                                    :class="[
                                        'form-group',
                                        errors.branch ? 'has-error' : '',
                                    ]"
                                >
                                    <button
                                        class="btn btn-danger"
                                        type="submit"
                                    >
                                        Add
                                    </button>
                                </div>
                            </form>
                        </div>
                        <div class="card-footer">
                            <button
                                class="btn btn-secondary"
                                data-dismiss="modal"
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal" tabindex="-1" role="dialog" id="viewModal">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">User Details</h5>
                            <button
                                type="button"
                                class="close"
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <p><b>Employee ID: </b>{{ form.emp_id }}</p>
                            <p><b>Branch: </b>{{ form.branch }}</p>
                            <p><b>APX User: </b>{{ form.apx_user_id }}</p>
                            <p><b>First Name: </b>{{ form.first_name }}</p>
                            <p><b>Last Name: </b>{{ form.last_name }}</p>
                            <p><b>Phone: </b>{{ form.phone }}</p>
                            <p><b>E-mail: </b>{{ form.email }}</p>
                            <p><b>User Type: </b>{{ form.user_type }}</p>
                        </div>
                        <div class="card-footer">
                            <button
                                class="btn btn-secondary"
                                data-dismiss="modal"
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal" tabindex="-1" role="dialog" id="editModal">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Edit User</h5>
                            <button
                                type="button"
                                class="close"
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <form @submit.prevent="editUser">
                                <div
                                    :class="[
                                        'form-group',
                                        errors.emp_id ? 'has-error' : '',
                                    ]"
                                >
                                    <label>Employee ID:</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder="Enter the ID of the employee"
                                        v-model="form.emp_id"
                                    />
                                    <span
                                        v-if="errors.emp_id"
                                        :class="['badge bg-danger']"
                                        >Please enter a valid ID.</span
                                    >
                                </div>
                                <div
                                    :class="[
                                        'form-group',
                                        errors.branch ? 'has-error' : '',
                                    ]"
                                >
                                    <label>Branch:</label>
                                    <v-select
                                        v-model="form.branch"
                                        type="text"
                                        label="BRANCH_NAME"
                                        :options="branches"
                                        :reduce="
                                            (branches) => branches.BRANCH_CODE
                                        "
                                        name="branch"
                                        placeholder="Select Branch"
                                        :value="
                                            (branches) => branches.BRANCH_CODE
                                        "
                                        @input="getEmployees"
                                    ></v-select>
                                    <span
                                        v-if="errors.branch"
                                        :class="['badge bg-danger']"
                                        >Please choose a valid branch.</span
                                    >
                                </div>
                                <div
                                    :class="[
                                        'form-group',
                                        errors.apx_user_id ? 'has-error' : '',
                                    ]"
                                >
                                    <label>APX User:</label>
                                    <v-select
                                        v-model="form.apx_user_id"
                                        type="text"
                                        label="SLPR_NAME"
                                        :options="employees"
                                        :reduce="
                                            (employees) => employees.SLPR_NAME
                                        "
                                        name="apx_user_id"
                                        placeholder="Select APX user"
                                        :value="
                                            (employees) => employees.SLPR_NAME
                                        "
                                    ></v-select>
                                    <span
                                        v-if="errors.apx_user_id"
                                        :class="['badge bg-danger']"
                                        >Please choose a valid user.</span
                                    >
                                </div>
                                <div
                                    :class="[
                                        'form-group',
                                        errors.first_name ? 'has-error' : '',
                                    ]"
                                >
                                    <label>First Name:</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder="Enter the first name of the employee"
                                        v-model="form.first_name"
                                    />
                                    <span
                                        v-if="errors.first_name"
                                        :class="['badge bg-danger']"
                                        >Please enter a valid name.</span
                                    >
                                </div>
                                <div
                                    :class="[
                                        'form-group',
                                        errors.last_name ? 'has-error' : '',
                                    ]"
                                >
                                    <label>Last Name:</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder="Enter the last name of the employee"
                                        v-model="form.last_name"
                                    />
                                    <span
                                        v-if="errors.last_name"
                                        :class="['badge bg-danger']"
                                        >Please enter a valid name.</span
                                    >
                                </div>
                                <div
                                    :class="[
                                        'form-group',
                                        errors.phone ? 'has-error' : '',
                                    ]"
                                >
                                    <label>Phone:</label>
                                    <input
                                        type="number"
                                        class="form-control"
                                        placeholder="Enter the phone number of the employee"
                                        v-model="form.phone"
                                        min="1000000000"
                                    />
                                    <span
                                        v-if="errors.phone"
                                        :class="['badge bg-danger']"
                                        >Please enter a valid number.</span
                                    >
                                </div>
                                <div
                                    :class="[
                                        'form-group',
                                        errors.email ? 'has-error' : '',
                                    ]"
                                >
                                    <label>E-mail:</label>
                                    <input
                                        type="email"
                                        class="form-control"
                                        placeholder="Enter the email of the employee"
                                        v-model="form.email"
                                    />
                                    <span
                                        v-if="errors.email"
                                        :class="['badge bg-danger']"
                                        >Please enter a valid email.</span
                                    >
                                </div>
                                <div
                                    :class="[
                                        'form-group',
                                        errors.user_type ? 'has-error' : '',
                                    ]"
                                >
                                    <label>User Type:</label>
                                    <select
                                        v-model="form.user_type"
                                        class="form-control"
                                    >
                                        <option value="sys-admin">
                                            System Administrator
                                        </option>
                                        <option value="service-tech">
                                            Service Technician
                                        </option>
                                        <option value="service-manager">
                                            Service Manager
                                        </option>
                                        <option value="service-agent">
                                            Service Agent
                                        </option>
                                        <option value="service-admin">
                                            Service Administrator
                                        </option>
                                        <option value="call-agent">
                                            Call Agent
                                        </option>
                                        <option value="user">Customer</option>
                                    </select>
                                    <span
                                        v-if="errors.user_type"
                                        :class="['badge bg-danger']"
                                        >Please enter valid matching
                                        passwords.</span
                                    >
                                </div>
                                <div
                                    :class="[
                                        'form-group',
                                        errors.branch ? 'has-error' : '',
                                    ]"
                                >
                                    <button
                                        class="btn btn-danger"
                                        type="submit"
                                    >
                                        Submit
                                    </button>
                                </div>
                            </form>
                        </div>
                        <div class="card-footer">
                            <button
                                class="btn btn-secondary"
                                data-dismiss="modal"
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal" tabindex="-1" role="dialog" id="passwdModal">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Change Password</h5>
                            <button
                                type="button"
                                class="close"
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <form @submit.prevent="changePasswd">
                                <div
                                    :class="[
                                        'form-group',
                                        errors.password ? 'has-error' : '',
                                    ]"
                                >
                                    <label>Password:</label>
                                    <input
                                        type="password"
                                        class="form-control"
                                        placeholder="Enter the password of the employee"
                                        v-model="form.password"
                                    />
                                    <span
                                        v-if="errors.password"
                                        :class="['badge bg-danger']"
                                        >Please enter valid matching
                                        passwords.</span
                                    >
                                </div>
                                <div
                                    :class="[
                                        'form-group',
                                        errors.password_confirmation
                                            ? 'has-error'
                                            : '',
                                    ]"
                                >
                                    <label>Confirm Password:</label>
                                    <input
                                        type="password"
                                        class="form-control"
                                        placeholder="Enter the password of the employee"
                                        v-model="form.password_confirmation"
                                    />
                                    <span
                                        v-if="errors.password_confirmation"
                                        :class="['badge bg-danger']"
                                        >Please enter valid matching
                                        passwords.</span
                                    >
                                </div>
                                <div
                                    :class="[
                                        'form-group',
                                        errors.branch ? 'has-error' : '',
                                    ]"
                                >
                                    <button
                                        class="btn btn-danger"
                                        type="submit"
                                    >
                                        Submit
                                    </button>
                                </div>
                            </form>
                        </div>
                        <div class="card-footer">
                            <button
                                class="btn btn-secondary"
                                data-dismiss="modal"
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- All VUE Parts end before this comment -->
        </div>
        <div v-if="!$gate.isServiceAdmin()">
            <access-denied></access-denied>
        </div>
    </div>
</template>

<script>
import Datatable from "../../datatable.vue";
import Pagination from "../../pagination.vue";
import { saveAs } from "file-saver";
export default {
    mounted() {
        console.log("Component mounted.");
    },

    components: { datatable: Datatable, pagination: Pagination },

    created() {
        this.getBranches();
        this.getUsers();
    },

    data() {
        let columns = [
            { width: "25%", label: "Name", name: "name" },
            { width: "25%", label: "Branch", name: "branch" },
            { width: "25%", label: "User Type", name: "user_type" },
            { width: "25%", label: "View More", name: "ops" },
        ];
        return {
            columns: columns,
            pagination: {
                lastPage: "",
                currentPage: "",
                total: "",
                lastPageUrl: "",
                nextPageUrl: "",
                prevPageUrl: "",
                from: "",
                to: "",
            },
            form: new Form({
                id: "",
                emp_id: "",
                first_name: "",
                last_name: "",
                phone: "",
                email: "",
                branch: "",
                password: "",
                user_type: "",
                activation: "",
                apx_user_id: "",
                password_confirmation: "",
                user_type: "",
            }),
            branch: "",
            results: "",
            name: "",
            user_type: "",
            branches: [],
            errors: [],
            employees: [],
            users: [],
        };
    },

    methods: {
        getBranches() {
            axios.post("/api/getBranches").then((response) => {
                this.branches = response.data;
            });
        },

        addModal() {
            this.form.reset();
            $("#addModal").modal("show");
        },

        addUser() {
            this.form
                .post("/api/addUser")
                .then((response) => {
                    if (response.data == 200) {
                        toast.fire({
                            title: "User Added",
                            icon: "success",
                        });
                        this.getUsers();
                        this.errors = [];
                    }
                })
                .catch((errors) => {
                    this.errors = errors.response.data.errors;
                    toast.fire({
                        title: "Operation Failed",
                        icon: "error",
                    });
                });
        },

        getEmployees() {
            axios
                .post("/api/getEmployees", { branch: this.form.branch })
                .then((response) => {
                    this.employees = response.data;
                });
        },

        configPagination(data) {
            this.pagination.lastPage = data.lastPage;
            this.pagination.currentPage = data.current_page;
            this.pagination.total = data.total;
            this.pagination.lastPageUrl = data.last_page_url;
            this.pagination.nextPageUrl = data.next_page_url;
            this.pagination.prevPageUrl = data.prev_page_url;
            this.pagination.from = data.from;
            this.pagination.to = data.to;
        },

        getUsers(url = "/api/getUsersSAdmin") {
            axios
                .post(url, {
                    results: this.results,
                    branch: this.branch,
                    searchName: this.name,
                    user_type: this.user_type,
                })
                .then((response) => {
                    this.users = response.data.data.data;
                    this.configPagination(response.data.data);
                });
        },

        view(man) {
            this.form.fill(man);
            $("#viewModal").modal("show");
        },

        edit(man) {
            this.form.fill(man);
            this.getEmployees();
            $("#editModal").modal("show");
        },

        reset() {
            this.results = "";
            this.branch = "";
            this.name = "";
            this.user_type = "";
            this.getUsers();
        },

        editUser() {
            this.form
                .post("/api/editUser")
                .then((response) => {
                    if (response.data == 200) {
                        toast.fire({
                            title: "User Updated",
                            icon: "success",
                        });
                        this.getUsers();
                        this.errors = [];
                        $("#editModal").modal("hide");
                    }
                })
                .catch((errors) => {
                    this.errors = errors.response.data.errors;
                    toast.fire({
                        title: "Operation Failed",
                        icon: "error",
                    });
                });
        },

        passwd(man) {
            this.form.fill(man);
            $("#passwdModal").modal("show");
        },

        changePasswd() {
            this.form
                .post("/api/changePasswd")
                .then((response) => {
                    if (response.data == 200) {
                        toast.fire({
                            title: "Password Updated",
                            icon: "success",
                        });
                        this.getUsers();
                        this.errors = [];
                        $("#passwdModal").modal("hide");
                    }
                })
                .catch((errors) => {
                    this.errors = errors.response.data.errors;
                    toast.fire({
                        title: "Operation Failed",
                        icon: "error",
                    });
                });
        },
    },
};
</script>
